import { Component, createSignal } from 'solid-js'
import { A, useNavigate } from '@solidjs/router'
import Modal from './Modal'
import Button from './Button'
import { i18nStore } from '../store/i18n'

const WelcomeModal: Component<{ show: boolean; onClose: () => void }> = (props) => {
  const i18n = i18nStore((s) => ({ language: s.language, t: s.t }))
  const navigate = useNavigate()
  const [termsAccepted, setTermsAccepted] = createSignal(false)

  const handleLanguageChange = (lang: 'en' | 'zh' | 'ja' | 'tw') => {
    i18nStore.setLanguage(lang)
  }

  const handleLogin = () => {
    if (!termsAccepted()) return
    navigate('/login')
    props.onClose()
  }

  const handleRegister = () => {
    if (!termsAccepted()) return
    navigate('/login?register=true')
    props.onClose()
  }

  return (
    <Modal
      show={props.show}
      close={props.onClose}
      title=""
      maxWidth="half"
      ariaLabel={i18n.t.welcomeTitle}
      dismissable={false}
    >
      <div class="flex flex-col gap-4 p-4 sm:p-6 md:p-8 bg-[var(--bg-800)] rounded-lg">
        {/* Title with emoji */}
        <div class="flex flex-col gap-4 sm:flex-row sm:items-center sm:justify-between">
          <h2 class="text-xl font-bold sm:text-2xl md:text-3xl text-white">
            {i18n.t.welcomeTitle} 👋
          </h2>
          
          {/* Language Selection */}
          <div class="flex gap-2">
            <button
              onClick={() => handleLanguageChange('en')}
              class={`px-3 py-1.5 rounded-md text-sm font-medium transition-all duration-200 ${
                i18n.language === 'en'
                  ? 'bg-gradient-to-r from-purple-600 to-pink-600 text-white shadow-lg'
                  : 'bg-[var(--bg-700)] text-[var(--text-500)] hover:bg-[var(--bg-600)]'
              }`}
            >
              EN
            </button>
            <button
              onClick={() => handleLanguageChange('zh')}
              class={`px-3 py-1.5 rounded-md text-sm font-medium transition-all duration-200 ${
                i18n.language === 'zh'
                  ? 'bg-gradient-to-r from-purple-600 to-pink-600 text-white shadow-lg'
                  : 'bg-[var(--bg-700)] text-[var(--text-500)] hover:bg-[var(--bg-600)]'
              }`}
            >
              简
            </button>
            <button
              onClick={() => handleLanguageChange('tw')}
              class={`px-3 py-1.5 rounded-md text-sm font-medium transition-all duration-200 ${
                i18n.language === 'tw'
                  ? 'bg-gradient-to-r from-purple-600 to-pink-600 text-white shadow-lg'
                  : 'bg-[var(--bg-700)] text-[var(--text-500)] hover:bg-[var(--bg-600)]'
              }`}
            >
              繁
            </button>
            <button
              onClick={() => handleLanguageChange('ja')}
              class={`px-3 py-1.5 rounded-md text-sm font-medium transition-all duration-200 ${
                i18n.language === 'ja'
                  ? 'bg-gradient-to-r from-purple-600 to-pink-600 text-white shadow-lg'
                  : 'bg-[var(--bg-700)] text-[var(--text-500)] hover:bg-[var(--bg-600)]'
              }`}
            >
              日本語
            </button>
          </div>
        </div>

        {/* Welcome Message */}
        <div class="flex flex-col gap-3 text-sm sm:text-base leading-relaxed text-[var(--text-300)]">
          <p>{i18n.t.welcomeMessage}</p>
          <p class="text-orange-400 font-medium">{i18n.t.welcomeDisclaimer}</p>
          <div class="flex items-start gap-2">
            <span class="text-orange-400">•</span>
            <p>{i18n.t.welcomeContentWarning}</p>
          </div>
        </div>

        {/* Terms Checkbox */}
        <div class="flex items-start gap-3">
          <input
            type="checkbox"
            id="terms-checkbox"
            checked={termsAccepted()}
            onChange={(e) => setTermsAccepted(e.currentTarget.checked)}
            class="mt-1 h-5 w-5 cursor-pointer rounded border-[var(--bg-600)] bg-[var(--bg-700)] text-purple-600 focus:ring-2 focus:ring-purple-500 focus:ring-offset-2 focus:ring-offset-[var(--bg-800)]"
          />
          <label for="terms-checkbox" class="text-sm sm:text-base text-[var(--text-300)] cursor-pointer flex-1">
            {i18n.t.termsAgreement}{' '}
            <A href="/terms-of-service" class="text-blue-400 hover:text-blue-300 underline">
              {i18n.t.termsLink}
            </A>
          </label>
        </div>

        {/* Action Buttons */}
        <div class="flex flex-col gap-3 sm:flex-row">
          <Button
            onClick={handleLogin}
            disabled={!termsAccepted()}
            class="flex-1 bg-gradient-to-r from-purple-600 to-pink-600 hover:from-purple-700 hover:to-pink-700 disabled:opacity-50 disabled:cursor-not-allowed text-white font-semibold py-3 transition-all duration-200 shadow-lg hover:shadow-xl"
            size="lg"
          >
            {i18n.t.login}
          </Button>
          <Button
            onClick={handleRegister}
            disabled={!termsAccepted()}
            class="flex-1 bg-gradient-to-r from-green-500 to-blue-500 hover:from-green-600 hover:to-blue-600 disabled:opacity-50 disabled:cursor-not-allowed text-white font-semibold py-3 transition-all duration-200 shadow-lg hover:shadow-xl"
            size="lg"
          >
            {i18n.t.register}
          </Button>
        </div>
      </div>
    </Modal>
  )
}

export default WelcomeModal

